import Controller, { OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import BaseController from '../../../BaseController';
import { FragmentNames, ScoreNasListAliases } from '../../../../codegen/index';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import { ApplicationRoute } from '../../../../constants/routes';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { Inject } from '@odinjs/odin';
import { PanelAPI } from '@philips-internal/oswald-ui-components';
import InformationBarUtils from '../../../../controllers/commons/header/information-bar-header-utils';
import { ScoreAndIndexesService } from '../../scores-list/scores-list-service';
import { ScoresAndIndexesStatusType } from '../../score-types';

@Controller ({ component: ScoreNasListAliases.LAYOUT_SCORE_NAS_LIST, fragment: FragmentNames.SCORE_NAS_LIST })
export default class ScoreNasListController extends BaseController {

  @Inject(ScoreNasListAliases.PANEL_GLOBAL_ACTIONS)
  private panelGlobalActions!: PanelAPI;

  @OnMount({ target: ScoreNasListAliases.PANEL_GLOBAL_ACTIONS })
  handlePanelGlobalActionsMount(): void {
    const allowInfo = InformationBarUtils.allowInfo && ScoreAndIndexesService.isAllowEdit;
    this.panelGlobalActions.setVisible(allowInfo);
  }

  @OnClick({ target: ScoreNasListAliases.ADD_SCORE_NAS_CUSTOM_DYNAMIC_BUTTON })
  handleOnClick(): void {
    const { encounterId, patientId } = this.historyService.getCurrentRouteParams();
    applicationContext.redirect(
      ApplicationRoute.SCORE_NAS_CREATE, {
        encounterId,
        patientId,
      }
    )
  }

  @OnClick({ target: ScoreNasListAliases.DECK_SCORE_NAS })
  handleOnClickCard(event: ClickEvent): void {
    const { idScoreIndexes, status } = event.value;
    const { encounterId, patientId } = this.historyService.getCurrentRouteParams();
    const allowInfo = InformationBarUtils.allowInfo && ScoreAndIndexesService.isAllowEdit;
    const accessViewer = ((status === ScoresAndIndexesStatusType.ACTIVE) || (!allowInfo))
    const route = accessViewer ? ApplicationRoute.SCORE_NAS_VIEWER : ApplicationRoute.SCORE_NAS_EDIT;

    applicationContext.redirect(route, {
      encounterId,
      idScoreIndexes,
      patientId,
    });
  }
}
